import React from 'react';
import SC2 from '../../assert/sc2.png'; // Verify this path or replace with your actual image path
import SC3 from '../../assert/sc3.png';
import SC4 from '../../assert/sc4.png';

const FeatureSection = ({ title, description, imageSrc, altText, reverse }) => {
  return (
    <section className="p-4 md:py-20 bg-gradient-to-b from-white to-gray-50">
      <div
        className={`max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center ${
          reverse ? 'md:[&>*:first-child]:order-2 md:[&>*:last-child]:order-1' : ''
        }`}
      >
        <div className="text-lg text-gray-800">
          <h2 className="text-3xl font-bold mb-5 bg-gradient-to-r from-[#2731a3] to-[#1a2280] bg-clip-text text-transparent text-left">
            {title}
          </h2>
          <p
            dangerouslySetInnerHTML={{ __html: description }}
            className="text-gray-600 leading-7 text-justify"
          />
        </div>
        <div className="flex justify-center">
          <img
            src={imageSrc}
            alt={altText}
            className="w-full max-w-lg rounded-lg shadow-lg border border-blue-700/10 hover:border-blue-700/30 transition-all duration-300"
          />
        </div>
      </div>
    </section>
  );
};

const FeatureSections = () => {
  return (
    <div>
      <FeatureSection
        title="Real-Time Payment Tracking"
        description="Easily manage homeowner payments with a dynamic dashboard that displays pending transactions, payment history, and client details. Use date filters and search tools to quickly locate records, and keep your community financially informed with up-to-date data and clear visibility into dues and balances."
        imageSrc={SC2}
        altText="Screenshot showing payment dashboard with transaction details"
        reverse={false}
      />
      <FeatureSection
        title="Amenity Booking"
        description="Simplify reservations with a user-friendly interface to book community amenities like clubhouses or pools. Check real-time availability, schedule effortlessly, and provide residents with a seamless booking experience."
        imageSrc={SC3}
        altText="Screenshot showing service request and amenity booking interface"
        reverse={true}
      />
      <FeatureSection
        title="Service Request"
        description="Efficiently manage community maintenance with a streamlined system for submitting and tracking service requests. From repairs to landscaping, monitor progress in real-time and ensure timely resolutions to keep your community running smoothly."
        imageSrc={SC4}
        altText="Screenshot showing project and task management interface"
        reverse={false}
      />
    </div>
  );
};

export default FeatureSections;